import React, { useState, useMemo, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import "../components/analyticsCards.css";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function MultiDepartmentAgreementPie({ departmentComparison = [] }) {

  // -----------------------
  // ✅ FLATTEN STRUCTURE
  // group → level → dept
  // -----------------------
  const flatData = useMemo(() => {

    const rows = [];

    departmentComparison.forEach(groupBlock => {
      (groupBlock.levels || []).forEach(levelBlock => {
        Object.entries(levelBlock.departments || {}).forEach(([dept, labelsObj]) => {

          rows.push({
            group: groupBlock.group,
            level: levelBlock.level,
            department: dept,
            labelsObj
          });

        });
      });
    });

    return rows;

  }, [departmentComparison]);


  // -----------------------
  // ✅ FILTER VALUES
  // -----------------------
  const deptList = useMemo(() => [...new Set(flatData.map(r => r.department))], [flatData]);
  const groupList = useMemo(() => [...new Set(flatData.map(r => r.group))], [flatData]);
  const levelList = useMemo(() => ["All", ...new Set(flatData.map(r => r.level))], [flatData]);


  const [selectedDepts, setSelectedDepts] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
const [selectedLevel, setSelectedLevel] = useState("All");
const [viewMode, setViewMode] = useState("percent"); // "count" | "percent"



  // Default selections
  useEffect(() => {
    if (deptList.length && !selectedDepts.length) setSelectedDepts([deptList[0]]);
    if (groupList.length && !selectedGroups.length) setSelectedGroups([groupList[0]]);
    if (levelList.length && selectedLevel === "All") setSelectedLevel(levelList[0]);

  }, [deptList, groupList, levelList]);


  // -----------------------
  // ✅ TOGGLES
  // -----------------------
  const toggle = (value, list, setList) => {
    setList(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
    );
  };

  const toggleDept = d => toggle(d, selectedDepts, setSelectedDepts);
  const toggleGroup = g => toggle(g, selectedGroups, setSelectedGroups);
  // const toggleLevel = l => toggle(l, selectedLevels, setSelectedLevels);


  // -----------------------
  // ✅ PIE DATA
  // -----------------------
  const LABEL_ORDER = ["Strongly agree", "Agree", "Disagree", "Strongly disagree"];
  const COLORS = ["#A81026", "#F3AC26", "#326AB3", "#4CBFAB"];

  const deptPieData = useMemo(() => {

    const result = {};

    selectedDepts.forEach(dept => {

      const totals = {
        "Strongly agree": 0,
        "Agree": 0,
        "Disagree": 0,
        "Strongly disagree": 0
      };

      flatData.forEach(row => {

        if (!selectedGroups.includes(row.group)) return;
        if (selectedLevel !== "All" && row.level !== selectedLevel) return;

        if (row.department !== dept) return;

        LABEL_ORDER.forEach(lbl => {
          totals[lbl] += row.labelsObj?.[lbl]?.count || 0;
        });

      });

      result[dept] = totals;

    });

    return result;

  }, [flatData, selectedDepts, selectedGroups, selectedLevel]);


  // -----------------------
  // ✅ UI
  // -----------------------
  return (
    <div className="textbox-viewer-wrapper">

      {/* <h2 className="analytics-title">🍩 Agreement Distribution</h2> */}

      <div className="analytics-layout">

{/* LEVEL DROPDOWN */}
{/* <div className="analytics-card" style={{ width: 220 }}>
  <h3 className="analytics-title">Level</h3>

  <select
    className="analytics-dropdown"
    value={selectedLevel}
    onChange={(e) => setSelectedLevel(e.target.value)}
    style={{ width: "100%", padding: 6, borderRadius: 6 }}
  >
    {levelList.map(lvl => (
      <option key={lvl} value={lvl}>{lvl}</option>
    ))}
  </select>
</div> */}
<div className="dgc-panel" style={{ width: 220 }}>
  <h3 className="dgc-panel-title">Level</h3>

  <select
    className="analytics-dropdown"
    value={selectedLevel}
    onChange={(e) => setSelectedLevel(e.target.value)}
    style={{ width: "100%", padding: 6, borderRadius: 6 }}
  >
    {levelList.map(lvl => (
      <option key={lvl} value={lvl}>{lvl}</option>
    ))}
  </select>
</div>

        {/* DEPT */}
        {/* <div className="analytics-card" style={{ width: 220 }}>
          <h3 className="analytics-title">Departments</h3>
          <div className="checkbox-list">
            {deptList.map(d => (
              <label key={d}>
                <input
                  type="checkbox"
                  checked={selectedDepts.includes(d)}
                  onChange={() => toggleDept(d)}
                />{" "}
                {d}
              </label>
            ))}
          </div>
        </div> */}



         <div className="dgc-panel" style={{ width: 220 }}>
          <h3 className="dgc-panel-title">Departments</h3>
          <div className="checkbox-list">
            {deptList.map(d => (
              <label key={d}>
                <input
                  type="checkbox"
                  checked={selectedDepts.includes(d)}
                  onChange={() => toggleDept(d)}
                />{" "}
                {d}
              </label>
            ))}
          </div>
        </div>

        {/* GROUP */}
        {/* <div className="analytics-card" style={{ width: 260 }}>
          <h3 className="analytics-title">Groups</h3>
          <div className="checkbox-list">
            {groupList.map(g => (
              <label key={g}>
                <input
                  type="checkbox"
                  checked={selectedGroups.includes(g)}
                  onChange={() => toggleGroup(g)}
                />{" "}
                {g}
              </label>
            ))}
          </div>
        </div>
      </div> */}


              <div className="dgc-panel" style={{ width: 260 }}>
          <h3 className="dgc-panel-title">Groups</h3>
          <div className="checkbox-list">
            {groupList.map(g => (
              <label key={g}>
                <input
                  type="checkbox"
                  checked={selectedGroups.includes(g)}
                  onChange={() => toggleGroup(g)}
                />{" "}
                {g}
              </label>
            ))}
          </div>
        </div>

        {/* VIEW MODE TOGGLE */}
<div className="dgc-panel" style={{ width: 200 }}>
  <h3 className="dgc-panel-title">View Mode</h3>

  <label style={{ display: "block" }}>
    <input
      type="radio"
      value="count"
      checked={viewMode === "count"}
      onChange={() => setViewMode("count")}
    />{" "}
    Count
  </label>

  <label style={{ display: "block" }}>
    <input
      type="radio"
      value="percent"
      checked={viewMode === "percent"}
      onChange={() => setViewMode("percent")}
    />{" "}
    Percentage (%)
  </label>
</div>

      </div>


      {/* PIE CHARTS */}
      <div className="analytics-pie-row">

        {selectedDepts.map(dept => {

          const totals = deptPieData[dept];

          return (
            <div key={dept} className="analytics-pie-card">
              <h3 className="analytics-pie-title">{dept}</h3>

              <Pie
  data={{
    labels: LABEL_ORDER,
    datasets: [{
      data: LABEL_ORDER.map(lbl => {
        if (viewMode === "count") return totals[lbl];
        const sum = Object.values(totals).reduce((a,b) => a + b, 0);
        return sum > 0 ? Number(((totals[lbl] / sum) * 100).toFixed(1)) : 0;
      }),
      backgroundColor: COLORS
    }]
  }}
  options={{
    plugins: {
      legend: { position: "bottom" },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            viewMode === "count"
              ? `${ctx.label}: ${ctx.raw}`
              : `${ctx.label}: ${ctx.raw}%`
        }
      }
    }
  }}
/>


              <div style={{ fontSize: 12, marginTop: 5, color: "#666" }}>
                {selectedLevel}

              </div>
            </div>
          );

        })}

      </div>

    </div>
  );
}
